import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Landing = lazy(() => import('../pages/landing/page'));
const Home = lazy(() => import('../pages/home/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Subjects = lazy(() => import('../pages/subjects/page'));
const SubjectDetail = lazy(() => import('../pages/subject-detail/page'));
const TestPreparation = lazy(() => import('../pages/test-preparation/page'));
const LearningSession = lazy(() => import('../pages/learning-session/page'));
const Achievements = lazy(() => import('../pages/achievements/page'));
const Progress = lazy(() => import('../pages/progress/page'));
const Reflection = lazy(() => import('../pages/reflection/page'));
const AIInsights = lazy(() => import('../pages/ai-insights/page'));
const UploadKnowledge = lazy(() => import('../pages/upload-knowledge/page'));
const Impressum = lazy(() => import('../pages/impressum/page'));
const Datenschutz = lazy(() => import('../pages/datenschutz/page'));
const AGB = lazy(() => import('../pages/agb/page'));
const Login = lazy(() => import('../pages/auth/login/page'));
const Register = lazy(() => import('../pages/auth/register/page'));
const VerifyEmail = lazy(() => import('../pages/auth/verify-email/page'));
const ResetPassword = lazy(() => import('../pages/auth/reset-password/page'));
const AuthCallback = lazy(() => import('../pages/auth/callback/page'));
const Onboarding = lazy(() => import('../pages/onboarding/page'));
const TestSupabase = lazy(() => import('../pages/test-supabase/page'));
const TestTelegram = lazy(() => import('../pages/test-telegram/page'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const AdminFeedback = lazy(() => import('../pages/admin-feedback/page'));
const AdminBetaCodes = lazy(() => import('../pages/admin-beta-codes/page'));
const Feedback = lazy(() => import('../pages/feedback/page'));
const AdminFeedbackOverview = lazy(() => import('../pages/admin-feedback-overview/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Partnership = lazy(() => import('../pages/partnership/page'));
import AskTeacherPage from '../pages/ask-teacher/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Landing />
  },
  {
    path: '/auth/login',
    element: <Login />
  },
  {
    path: '/auth/register',
    element: <Register />
  },
  {
    path: '/auth/verify-email',
    element: <VerifyEmail />
  },
  {
    path: '/auth/reset-password',
    element: <ResetPassword />
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />
  },
  {
    path: '/onboarding',
    element: <ProtectedRoute><Onboarding /></ProtectedRoute>
  },
  {
    path: '/test-supabase',
    element: <TestSupabase />
  },
  {
    path: '/test-telegram',
    element: <TestTelegram />
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>
  },
  {
    path: '/subjects',
    element: <ProtectedRoute><Subjects /></ProtectedRoute>
  },
  {
    path: '/subject/:id',
    element: <ProtectedRoute><SubjectDetail /></ProtectedRoute>
  },
  {
    path: '/test-preparation',
    element: <TestPreparation />
  },
  {
    path: '/learning-session',
    element: <ProtectedRoute><LearningSession /></ProtectedRoute>
  },
  {
    path: '/achievements',
    element: <ProtectedRoute><Achievements /></ProtectedRoute>
  },
  {
    path: '/progress',
    element: <ProtectedRoute><Progress /></ProtectedRoute>
  },
  {
    path: '/reflection',
    element: <ProtectedRoute><Reflection /></ProtectedRoute>
  },
  {
    path: '/ai-insights',
    element: <ProtectedRoute><AIInsights /></ProtectedRoute>
  },
  {
    path: '/upload-knowledge',
    element: <UploadKnowledge />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/partnerschaft',
    element: <Partnership />
  },
  {
    path: '/feedback',
    element: <ProtectedRoute><Feedback /></ProtectedRoute>
  },
  {
    path: '/impressum',
    element: <Impressum />
  },
  {
    path: '/datenschutz',
    element: <Datenschutz />
  },
  {
    path: '/agb',
    element: <AGB />
  },
  {
    path: '/ask-teacher',
    element: <ProtectedRoute><AskTeacherPage /></ProtectedRoute>
  },
  {
    path: '/admin/feedback',
    element: <ProtectedRoute><AdminFeedback /></ProtectedRoute>
  },
  {
    path: '/admin/feedback-overview',
    element: <ProtectedRoute><AdminFeedbackOverview /></ProtectedRoute>
  },
  {
    path: '/admin/beta-codes',
    element: <ProtectedRoute><AdminBetaCodes /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
